module.exports = __webpack_public_path__ + "img/沙漠球球1920x470.30156bc6.jpg";